export default __webpack_public_path__ + "media/images/people-8392559965fe796eb74aadb4e6c35fde.svg";